(()=>{
  const normalize=value=>String(value).normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().replace(/[^a-z0-9\s]/g,' ').replace(/\s+/g,' ').trim();
  function initialize(scope=document){
    scope.querySelectorAll('[data-sg-search-examples]').forEach(input=>{
      if(input.dataset.examplesReady)return;input.dataset.examplesReady='true';
      const examples=input.dataset.sgSearchExamples.split('|').filter(Boolean);
      const original=input.placeholder;
      const reducedMotion=matchMedia('(prefers-reduced-motion: reduce)');
      const desktop=matchMedia('(min-width: 1200px)');
      let timer,index=0,length=0,deleting=false;
      const available=()=>(input.hasAttribute('data-sg-search-all-sizes')||desktop.matches)&&!reducedMotion.matches&&!document.hidden&&document.activeElement!==input&&!input.value;
      function stop(){clearTimeout(timer);input.placeholder=original;}
      function tick(){
        if(!available()){stop();return;}
        const example=examples[index];
        length+=deleting?-1:1;
        input.placeholder=example.slice(0,length);
        let delay=deleting?45:90;
        if(length===example.length){deleting=true;delay=2200;}
        else if(length===0){deleting=false;index=(index+1)%examples.length;delay=600;}
        timer=setTimeout(tick,delay);
      }
      function start(){stop();index=0;length=0;deleting=false;if(examples.length&&available())timer=setTimeout(tick,1000);}
      input.addEventListener('focus',stop);
      input.addEventListener('input',stop);
      input.addEventListener('blur',start);
      reducedMotion.addEventListener('change',start);
      desktop.addEventListener('change',start);
      document.addEventListener('visibilitychange',start);
      start();
    });
    scope.querySelectorAll('[data-sg-team-directory]').forEach(directory=>{
      if(directory.dataset.ready)return;
      directory.dataset.ready='true';
      const search=directory.querySelector('[data-team-search]');
      const filters=[...directory.querySelectorAll('[data-team-filter]')];
      const items=[...directory.querySelectorAll('[data-team-item]')];
      const status=directory.querySelector('[data-team-status]');
      const empty=directory.querySelector('[data-team-empty]');
      const params=new URLSearchParams(location.search);
      let league=params.get('league')||'all';
      if(!filters.some(button=>button.dataset.teamFilter===league))league='all';
      search.value=params.get('q')||'';
      function render(){
        const tokens=normalize(search.value).split(' ').filter(Boolean);
        let count=0;
        items.forEach(item=>{
          const text=normalize(item.dataset.teamSearch);
          const match=(league==='all'||item.dataset.teamLeague===league)&&tokens.every(token=>text.includes(token));
          item.hidden=!match;if(match)count++;
        });
        filters.forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.teamFilter===league)));
        status.textContent=count===1?status.dataset.singleLabel:status.dataset.label.replace('[count]',count);
        empty.hidden=count>0;
      }
      search.addEventListener('input',render);
      filters.forEach(button=>button.addEventListener('click',()=>{league=button.dataset.teamFilter;render();}));
      directory.querySelector('form').addEventListener('submit',event=>{event.preventDefault();render();});
      render();
    });
    scope.querySelectorAll('[data-sg-team-menu]').forEach(menu=>{
      if(menu.dataset.ready)return;menu.dataset.ready='true';
      const tabs=[...menu.querySelectorAll('[data-team-menu-group]')];
      const panels=[...menu.querySelectorAll('[data-team-menu-panel]')];
      const heading=menu.querySelector('[data-team-menu-heading]');
      const hover=matchMedia('(min-width: 1200px) and (hover: hover) and (pointer: fine)');
      let closeTimer;
      menu.addEventListener('mouseenter',()=>{clearTimeout(closeTimer);if(hover.matches)menu.open=true;});
      menu.addEventListener('mouseleave',()=>{if(hover.matches)closeTimer=setTimeout(()=>{if(!menu.contains(document.activeElement)||document.activeElement===menu.querySelector('summary'))menu.open=false;},230);});
      function activate(tab){
        tabs.forEach(button=>button.setAttribute('aria-selected',String(button===tab)));
        panels.forEach(panel=>panel.hidden=panel.dataset.teamMenuPanel!==tab.dataset.teamMenuGroup);
        heading.textContent=tab.textContent;
      }
      tabs.forEach((tab,index)=>{
        tab.addEventListener('click',()=>activate(tab));
        tab.addEventListener('keydown',event=>{
          if(!['ArrowUp','ArrowDown','Home','End'].includes(event.key))return;
          event.preventDefault();
          let next=event.key==='Home'?0:event.key==='End'?tabs.length-1:(index+(event.key==='ArrowDown'?1:-1)+tabs.length)%tabs.length;
          activate(tabs[next]);tabs[next].focus();
        });
      });
      menu.addEventListener('keydown',event=>{if(event.key==='Escape'){event.preventDefault();menu.open=false;menu.querySelector('summary').focus();}});
      document.addEventListener('click',event=>{if(menu.open&&!menu.contains(event.target))menu.open=false;});
      menu.addEventListener('toggle',()=>{
        menu.querySelector('summary').setAttribute('aria-expanded',String(menu.open));
        if(menu.open){document.querySelectorAll('header-menu details[open]').forEach(other=>other.open=false);document.body.classList.remove('megashowBefore');}
      });
      document.querySelectorAll('header-menu details').forEach(other=>other.addEventListener('toggle',()=>{if(other.open)menu.open=false;}));
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initialize());else initialize();
  document.addEventListener('shopify:section:load',event=>initialize(event.target));
  document.addEventListener('change',event=>{if(event.target.matches('[data-team-collection-select]')&&event.target.value)location.assign(event.target.value);});
})();
